import styled, { keyframes } from 'styled-components';

// Animação para o loading spinner
const spin = keyframes`
  0% { transform: translateY(-50%) rotate(0deg); }
  100% { transform: translateY(-50%) rotate(360deg); }
`;

export const Container = styled.div`
  padding-bottom: 40px;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
`;

export const HeaderIndicator = styled.div`
  width: 4px;
  height: 24px;
  background-color: ${(props: any) => props.theme.colors.primaryRed400};
  border-radius: 2px;
  margin-right: 12px;
`;

export const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c2d3748};
  margin: 0;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

// Container especial para a linha com 3 campos (CEP, Rua e Bairro)
export const ThreeColumnRow = styled.div`
  display: grid;
  grid-template-columns: 10% 1fr 1fr; // CEP 10%, Rua e Bairro dividem o espaço restante igualmente
  gap: 20px;
  grid-column: 1 / -1; // Ocupa toda a largura do grid pai
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// Container para linha de número e complemento
export const TwoColumnRow = styled.div`
  display: grid;
  /* Mantém as mesmas linhas do ThreeColumnRow para alinhamento perfeito */
  grid-template-columns: 10% 1fr 1fr;
  gap: 16px;
  grid-column: 1 / -1;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  &.cep {
    grid-column: 1 / 2; // 10% - CEP
    @media (max-width: 768px) {
      grid-column: 1 / -1;
    }
  }
  
  &.rua {
    grid-column: 2 / 3; // 45% - Rua (metade do espaço restante)
    @media (max-width: 768px) {
      grid-column: 1 / -1;
    }
  }
  
  &.bairro {
    grid-column: 3 / 4; // 45% - Bairro (metade do espaço restante)
    @media (max-width: 768px) {
      grid-column: 1 / -1;
    }
  }
  
  &.numero { grid-column: 1 / 2; }
  &.complemento { grid-column: 2 / 3; }
  &.endereco-virtual { 
    grid-column: 3 / 4; 
    min-width: 0; /* evita overflow dentro da coluna */
  }
`;

export const Label = styled.label<{ required?: boolean }>`
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c4a5568};
  margin-bottom: 6px;
  position: relative;

  ${props => props.required && `
    &::after {
      content: '*';
      color: ${(props: any) => props.theme.colors.ce53e3e};
      margin-left: 4px;
      font-weight: 700;
    }
  `}
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: 12px 16px;
  border: ${props => props.hasError ? '1px solid #e53e3e' : '1px solid #e2e8f0'};
  border-radius: 6px;
  font-size: 0.875rem;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  transition: border-color 0.2s ease;
  outline: none;

  &:hover {
    border: 1px solid ${(props: any) => props.theme.colors.c000000};
  }

  &:focus {
    border: 1px solid ${(props: any) => props.theme.colors.c000000};
  }

  &:blur {
    border-color: ${props => props.hasError ? 'var(--ce53e3e)' : 'var(--ce2e8f0)'};
  }
`;

export const LoadingSpinner = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-top: 2px solid ${(props: any) => props.theme.colors.primaryRed400};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const ErrorMessage = styled.p`
  font-size: 0.75rem;
  color: ${(props: any) => props.theme.colors.ce53e3e};
  margin: 4px 0 0 0;
`;
